import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { EASE } from "@/lib/motion";
import { IMAGES } from "@/data/content";

const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="invitation"
      ref={ref}
      data-testid="final-cta-section"
      className="relative h-[90vh] min-h-[560px] overflow-hidden grain scroll-mt-24"
    >
      <motion.div className="absolute inset-0" style={{ y }}>
        <img
          src={IMAGES.corporate}
          alt="Sunlight through a tranquil forest"
          loading="lazy"
          decoding="async"
          className="h-[124%] w-full object-cover -top-[12%] absolute"
        />
      </motion.div>
      <div className="absolute inset-0 bg-forest/65" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/40 to-transparent" aria-hidden="true" />

      <div className="relative z-10 h-full mx-auto max-w-[1600px] px-6 md:px-10 flex flex-col items-center justify-center text-center">
        <Reveal>
          <p className="kicker text-gold mb-8">Your invitation</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif font-light text-ivory text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight max-w-4xl text-balance">
            Begin a conversation that returns you to yourself.
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-8 text-ivory/75 leading-relaxed max-w-xl mx-auto md:text-lg">
            Whether for yourself, your team, or a season of retreat — we would be
            honoured to design a journey around you.
          </p>
        </Reveal>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE, delay: 0.22 }}
          className="mt-12"
        >
          <Link
            to="/contact"
            data-testid="final-cta-button"
            className="group inline-flex items-center gap-3 bg-ivory text-forest px-10 py-5 uppercase tracking-[0.16em] text-xs transition-colors duration-500 hover:bg-gold"
          >
            Book a Consultation
            <span className="transition-transform duration-500 group-hover:translate-x-1">→</span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
